<template>
  <v-footer color="primary" absolute app class="app-footer">
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12" xl="5" lg="5" md="5" sm="6" xs="12">
          <v-row align="left" justify="center">
            <div>
              <a @click="onHome">
                <v-img
                  src="@/assets/aquaduct.jpg"
                  height="auto"
                  width="100%"
                >
                </v-img>
              </a>
            </div>
          </v-row>
        </v-col>
        <v-col cols="12" xl="2" lg="2" md="2" sm="6" xs="12">
          <v-row>
            <social-buttons class="social"></social-buttons>
          </v-row>
        </v-col>
        <v-col cols="12" xl="2" lg="2" md="2" sm="6" xs="12">
          <v-row align="center" justify="center">
            <v-icon>mdi-sitemap</v-icon>
            <div class="site-map" @click="onSiteMap">{{ get("site-map")}}</div>
          </v-row>
        </v-col>
        <v-col cols="12" xl="3" lg="3" md="3" sm="6" xs="12">
          <v-row align="right" justify="center"  v-if="user.id != ''">
            <v-icon>mdi-account</v-icon> {{ user.firstName }} {{ user.lastName }}
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import breakpointMixin from "../../mixins/breakpointMixin"

import store from "@/store"
import settingsService from "@/_services/settings-service";
import social from "@/components/app/social-buttons";
import localizationMixin from "@/mixins/localization-mixin";

export default {
  name: "app-footer",

  components: {
    "social-buttons": social,
  },


  created() {
    this.user = store.getters.getUser
    this.pageName = "footer"
  },

  data: () => ({
    copyright: String.fromCharCode(184),
    company: settingsService.get("company"),
    environment: settingsService.get("environment"),
    version: settingsService.get("version"),
    user: {
      firstName: "",
      lastName: "",
    },
    year: new Date().getFullYear(),
  }),

  mixins: [breakpointMixin, localizationMixin],

  methods: {
    // onRefresh() {
    // menuService.load()
    // colorService.load()
    // },

    getLocalization(){},
    
    onHome() {
      if(this.$route.path != "/") {
        this.$router.push("/")
      }
    },

    onSiteMap() {
      console.log("onSiteMap()");
      // const list = this.getRoutesList(router.options.routes, "http://aquaductroofing.com")
      //   .map(route => `<url><loc>${route}</loc></url>`)
      //   .join('\r\n');
      // const siteMap = `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
      //   ${list}
      //   </urlset>`

      // var blob = new Blob([siteMap], { type: 'application/xml' })
      // var a = document.createElement('a');
      // a.download = 'sitemap.xml'
      // a.href = URL.createObjectURL(blob)
      // a.dataset.downloadurl = ['application/xml', a.download, a.href].join(':')
      // a.style.display = "none"
      // document.body.appendChild(a)
      // a.click()
      // document.body.removeChild(a)
      // setTimeout(function() {URL.revokeObjectURL(a.href); }, 1500)
    },
  },

  watch: {
    "$store.state.user"() {
      this.user = store.getters.getUser
      console.log("footer.user()", this.user);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/variables.scss";
.app-footer {
  height: 180px;
  padding-bottom: 50px
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.container {
  margin-bottom: -70px;
  width: 100%;
}

.site-map {
  margin-left: 5px;
}

.social {
  margin-top: -16px;
}

@media (min-width: 1264px) {
  .container {
    width: 100%;
  }
}
@media (min-width: 960px) {
  .container {
    width: 100%;
  }
}
</style>
